import { useModal } from "hooks/useModal"
import { useAppDispatch } from "reducers/store"

import styled from "styled-components"
import { useCallback, memo } from "react"
import { setAccount } from "reducers/accounts/accounts-actions"
import clsx from "clsx"
import { Colors } from "themes/palette"
import Tooltip from "components/Tooltip"
import IconBlockUser from "components/EvtKit/icons/IconBlockUser"

const InlineButton = styled.div`
  width: 25px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 16px;

  svg {
    width: 25px;
    height: 24px;
  }

  &.disabled {
    cursor: not-allowed;
  }
`

interface BlockOrActiveEnterpriseAccountButtonProps {
  account: App.Account
}

const BlockOrActiveEnterpriseAccountButton = (props: BlockOrActiveEnterpriseAccountButtonProps) => {
  const { account } = props

  const appDispatch = useAppDispatch()

  const { openModal } = useModal()

  const disabledButton = !(account.isEnterprise && account.shouldPayByInvoice)

  const handleOnClick = useCallback(async () => {
    if (disabledButton) return

    openModal("blockEnterpriseAccount")
    appDispatch(setAccount(account))
  }, [account, disabledButton])

  const tooltipText = disabledButton
    ? "Só é possível Bloquear/Ativar contas que sejam enterprise e que paguem por fatura"
    : "Bloquear/Reativar conta"

  return (
    <Tooltip text={tooltipText} toolTipClassName="align-right position-absolute">
      <InlineButton onClick={handleOnClick} className={clsx({ disabled: disabledButton })}>
        <IconBlockUser color={disabledButton ? Colors.disabled : Colors.primary_one} />
      </InlineButton>
    </Tooltip>
  )
}

export default memo(BlockOrActiveEnterpriseAccountButton)
